/**
 * 函数防抖封装
 * @param {*} func 回调函数
 * @param {*} delay  时间
 */
export function _debounce (func, delay = 100) {
  let timer = null // 用于保存定时器
  // 如果定时器存在，清除定时器，随后重新设置timer
  return function (...args) {
    if (timer !== null) clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

/**
 * 节流函数
 * @param {*} func 函数
 * @param {*} delay 延迟时间
 * @returns
 */
export function _throttle (func, delay = 100) {
  let timer = null

  if (timer) clearTimeout(timer)
  return function (...args) {
    // 如果定时器不存在
    if (!timer) {
      timer = setTimeout(() => {
        func.apply(this, args) // 考虑返回的函数调用的环境，因此这里不直接使用this
        timer = null // delay之后清除定时器
      }, delay)
    }
  }
}

/**
 * 节流函数立即执行版本
 * @param {*} func
 * @param {*} delay
 * @returns
 */
export function _throttleImmidiate (func, delay) {
  // 上次执行的时间
  let preTime = 0
  return function (...args) {
    if (!preTime) {
      preTime = Date.now()
      return
    }
    // 取时间间隔大于延迟的才会执行
    if (Date.now() - preTime > delay) {
      func.apply(this, args)
      preTime = Date.now()
    }
  }
}

// 时间戳转换时间格式 时间 转换
export function timetransition (timestamp, format = 'Y-M-D h:m:s', bool) {
  /** 时间戳转时间格式 1605922322000 转换  z2021-01-14 11:03:31
   * @params timestamp需要转化的时间戳 format格式类型
   * Y-M-D h:m:s 年-月-日（大写） 时:分:秒（小写）
   */
  if (timestamp === undefined) {
    return ''
  }
  // 这里添加了一个判断
  if (String(timestamp).length == 10) {
    var date = new Date(timestamp * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
  } else {
    var date = new Date(timestamp)
  }
  let obj = null
  if (bool) {
    obj = {
      Y: date.getFullYear(),
      M: date.getMonth() + 1,
      D: date.getDate(),
      h: date.getHours(),
      m: date.getMinutes(),
      s: date.getSeconds()
    }
  } else {
    obj = {
      Y: date.getFullYear(),
      M:
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1,
      D: date.getDate() < 10 ? '0' + date.getDate() : date.getDate(),
      h: date.getHours() < 10 ? '0' + date.getHours() : date.getHours(),
      m: date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(),
      s: date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    }
  }
  const newitem = format.split('').map(item => {
    for (const key in obj) {
      if (item == key) {
        item = obj[key]
      }
    }
    return item
  })
  return newitem.join('')
}

/**
 *  格式化的时间转换为毫秒时间戳
 *
 *  @param str 时间字符串
 *  @param isEnd 是否是结束时间
 *  @return 毫秒时间搓
 */
function dateParseTime (str, isEnd) {
  if (str === null || !str) {
    return ''
  }
  /* 将 Wed Aug 26 2020 09:20:58 GMT+0800 (中国标准时间) 格式 转换为 1598404858000 */
  str = new Date(str).getTime()
  /* 将 1598404858000 转换为 2020-08-27 09:20:58 */
  // 看需求 是否需要转
  // let startTimes = formatDate(new Date(str));
  if (isEnd) {
    str += 999
  }
  // str = Date.parse(new Date(str).getTime());
  return str
}

/**
 *  *  用途：时间戳转换
 * @param {Object} date 传入时间戳 2020-09-03T16:35:54+08:00
 * @param {string} date 返回时间 2020-09-03 08:35:54
 */
function rTime (date) {
  var json_date = new Date(date).toJSON()
  return new Date(new Date(json_date) + 8 * 3600 * 1000)
    .toISOString()
    .replace(/T/g, ' ')
    .replace(/\.[\d]{3}Z/, '')
}

// rTime("2020-09-03T16:35:54+08:00");  返回2020-09-03 08:35:54

/**
 *  截取指定符号前面 或者后面的字段  传0截取前面 ，1 后面
 * @param {*} lastIndexOf('_')  _ 下滑线是知道的符号 -  +   方便截取Id用
 * @param {*} state
 */
export function getCaption (obj, state) {
  var index = obj.lastIndexOf('_')
  if (state == 0) {
    obj = obj.substring(0, index)
  } else {
    obj = obj.substring(index + 1, obj.length)
  }
  return obj
}

export function cutout (obj, state) {
  var index = obj.lastIndexOf('-')
  if (state == 0) {
    obj = obj.substring(0, index)
  } else {
    obj = obj.substring(index + 1, obj.length)
  }
  return obj
}

export function truncate (obj, state, st) {
  var index = obj.lastIndexOf(',')
  if (state == 0) {
    obj = obj.substring(0, index)
  } else {
    obj = obj.substring(index + 1, obj.length)
  }
  return obj
}

/**
 *  计算时间差返回结果
 * @param
 */
export function getDiffDays (date1, date2) {
  // 得到总秒数
  var ss = Math.abs(date2 - date1) / 1000
  // 得到天数
  var day = Math.floor(ss / 3600 / 24)
  // 得到不满一天的小时数
  var hour = Math.floor((ss / 3600) % 24)
  // 得到不满一小时的分钟数
  var minute = Math.floor((ss / 60) % 60)
  // 得到不满一分钟的秒数
  var second = Math.floor(ss % 60)
  if(day !== 0){
    return (
      day +
      $t('integration.day') +
      hour +
      $t('integration.hour') +
      minute +
      $t('integration.branch')
    )
  }else{
    if(hour !== 0){
      return (
        hour +
        $t('integration.hour') +
        minute +
        $t('integration.branch')
      )
    }else{
      return (
        minute +
        $t('integration.branch')
      )
    }
    
  }
  
  // return $t('integration.surplus') + day + $t('integration.day') + hour + $t('integration.hour') + minute + $t('integration.branch') + second + $t('integration.second')
}

/**
 * js 判断数组内元素是否全相同
 * 判断数组是否为空数组 isEmptyObject
 * 返回 ture 则是空数组
 * @param {*} array 传入的数组
 *
 */
export function isAllEqual (array) {
  if (array.length > 0) {
    return !array.some(function (value, index) {
      return value !== array[0]
    })
  } else {
    return true
  }
}

/**
 *  数组去重
 * @param {*} val
 */
export function arrayUnique (arr) {
  const newArr = []
  const len = arr.length
  for (let i = 0; i < len; i++) {
    if (newArr.indexOf(arr[i]) == -1) {
      newArr.push(arr[i])
    }
  }
  return newArr
}

/**
 *  数组对象去重
 * @param {*} val
 */
//  方法2：利用reduce方法遍历数组,reduce第一个参数是遍历需要执行的函数，第二个参数是item的初始值
export function arrayObjUnique (arr, key) {
  const obj = {}
  let res = []
  res = arr.reduce((prev, item) => {
    obj[key] ? '' : (obj[key] = true && prev.push(item))
    return prev
  }, [])
  return res
}

/**
 *
 * @param {*} val 传进来的是查询条件 - 字符串
 * @param {*} treeData  传进来的是个数组，根据条件在这个数组查询对应的数据 用于树形控件查找
 */
export function treeText (val, tree) {
  if (Array.isArray(tree)) {
    const list = []
    const convert = tree => {
      tree.filter(items => {
        if (items.label.indexOf(val) > -1) {
          list.push(items)
        } else {
          if (items.item) {
            return convert(items.item)
          }
        }
      })
    }
    convert(tree)
    return list
  } else {
    return false
  }
}

/**
 *  判断两个数组是否有相同的值
 *  var a1 = [1, 2, 5, 8];
 *  var a2 = [3, 1, 9, 5];
 * @param {*} a1
 * @param {*} a2
 * @returns
 */

export function ExistsSameValues (a1, a2) {
  var exists = false
  if (a1 instanceof Array && a2 instanceof Array) {
    for (var i = 0, iLen = a1.length; i < iLen; i++) {
      for (var j = 0, jLen = a2.length; j < jLen; j++) {
        if (a1[i] === a2[j]) {
          return true
        }
      }
    }
  }
  return exists
}

/**
 * 用于查找树形控件的父节点信息 - 递归查找所有父节点信息
 * @param array 传进一个数组，
 * @param key 传进的是字符串id
 *
 * @param str 这里添加一个str参数 代表匹配值  为了不影响之前的代码  给他默认值为id  author:brian date:2022 05 10
 */
export function getParent (array, key, str = 'id') {
  const result = []
  let toToo = true
  const catchData = (array, key) => {
    array.forEach(item => {
      if (!toToo) return
      result.push(item)
      if (item[str] === key) {
        toToo = false
      } else if (item.item) {
        catchData(item.item, key)
      } else {
        result.pop()
      }
    })
    toToo && result.pop()
  }
  catchData(array, key)
  return result
}

/**
 *  根据对象数组中对象属性值的不同将数组进行分组
 * @param {*} initialArr 传入的数组 必须是数组
 *  @param {*} name 条件字段  一般为id
 *  用于树形菜单搜索
 */

export function formateArrData (initialArr, name) {
  if (!(initialArr instanceof Array)) {
    return $t('integration.please_pass_in_an_array_with_the_correct_format')
  }
  if (!name) {
    return $t('integration.please_pass_in_the_object_property')
  }
  // 先获取一下这个数组中有多少个"name"
  const nameArr = []
  for (let i = 0; i < initialArr.length; i++) {
    if (nameArr.indexOf(initialArr[i][`${name}`]) === -1) {
      nameArr.push(initialArr[i][`${name}`])
    }
  }
  console.log(nameArr)
  // 新建一个包含多个list的结果对象
  const tempObj = {}
  // 根据不同的"name"生成多个数组
  for (const k in nameArr) {
    for (const j in initialArr) {
      if (initialArr[j][`${name}`] == nameArr[k]) {
        // 每次外循环时新建一个对应"name"的数组, 内循环时当前数组不变
        tempObj[nameArr[k]] = tempObj[nameArr[k]] || []
        tempObj[nameArr[k]].push(initialArr[j])
      }
    }
  }
  return tempObj
}

/**
 *   getAllLeaf 递归树结构数据查找所有叶子节点，树形结构展平成数组
 * @param {*} data
 * @returns
 */

export function getAllLeaf (data) {
  const result = []

  function getLeaf (data) {
    data.forEach(item => {
      if (!item.children) {
        result.push(item)
      } else {
        getLeaf(item.children)
      }
    })
  }

  getLeaf(data)
  return result
}

/**
 * @param 判断两个数组里的对象id是否存在相同，相同则返回 true
 * @param {*} arr1
 * @param {*} arr2
 */

export function mergeArr (arr1, arr2) {
  let flag = false
  for (let i = 0; i < arr2.length; i++) {
    for (let j = 0; j < arr1.length; j++) {
      if (arr1[j].id == arr2[i].id) {
        flag = true
        break
      }
    }
  }
  return flag
}

/**
 * getPlaceholderCount  统计字符串中包含某个字符的个数 // js 转corn 表达式
 * @param
 */

export function getPlaceholderCount (strSource) {
  var count1 = 0 // ?的个数
  var count2 = 0 // *的个数
  // strSource.replace(/\*|\?/g, function (m, i) 正则把 ？ 号改为 *号
  strSource.replace('', function (m, i) {
    if (m === '?') {
      count1++
    } else if (m === '*') {
      count2++
    }
  })
  var obj = {}
  obj.count1 = count1
  obj.count2 = count2

  return obj // 返回一个对象，根据需要得到想要的值
}

/**
 * 下载文件流
 * @param {*} data
 */
export function download (data) {
  if (!data) {
    return
  }
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', 'excel.xlsx')
  document.body.appendChild(link)
  link.click()
}

/**
 * 控制树形控件的图表
 * @param {*} obj
 * @param {*} state
 */
export function renderTerr (nodedata, createElement, ats) {
  if (nodedata.scene_type === 0) {
    return createElement('span', [
      createElement('i', { attrs: { class: 'iconfont iconsale-3' } }),
      createElement('span', '     '),
      createElement('span', ats.node.label)
    ])
  } else if (nodedata.scene_type === 1) {
    return createElement('span', [
      createElement('i', { attrs: { class: 'iconfont iconditu' } }),
      createElement('span', '     '),
      createElement('span', ats.node.label)
    ])
  } else if (nodedata.scene_type === 2) {
    return createElement('span', [
      createElement('i', { attrs: { class: 'iconfont iconditu1' } }),
      createElement('span', '     '),
      createElement('span', ats.node.label)
    ])
  } else {
    return createElement('span', [
      // createElement('i', { attrs: { class: 'iconfont iconditu' } }),
      //  createElement('i', { attrs: { class: 'el-icon-platform-eleme' } }),
      createElement('span', '     '),
      createElement('span', ats.node.label)
    ])
  }
}

/**
 * 数字转中文
 * @param {*} code 传入的数字
 * @param {*} data  传进来的是个数组
 */
export function getdictionary (code, data) {
  for (let index = 0; index < data.length; index++) {
    const element = data[index]
    if (element.code == code) {
      return element.text
    } else {
    }
  }
}

/**
 * 验证IP地址格式
 * @param {String} value IP地址
 */
export function validateIP (value) {
  const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
  return reg.test(value)
}

/**
 * 验证IP地址格式
 * @param {String} value IP地址
 */
export function ipToNumber (ip) {
  var num = 0
  if (ip === '') {
    return num
  }
  var aNum = ip.split('.')
  if (aNum.length !== 4) {
    return num
  }
  num += parseInt(aNum[0]) << 24
  num += parseInt(aNum[1]) << 16
  num += parseInt(aNum[2]) << 8
  num += parseInt(aNum[3]) << 0
  num = num >>> 0 // 这个很关键，不然可能会出现负数的情况
  return num
}

/**
 * 验证端口格式
 * @param {String} value prot端口
 */
export function validatePort (value) {
  var parten = /^(\d)+$/g
  return parten.test(value)
}

/**
 * 验证0-10格式
 * @param {String} value
 */
export function validateNum (value) {
  var parten = /^\d{1,10}$/
  return parten.test(value)
}

export function validateNums (value) {
  var parten = /^\d{3,3}$/
  return parten.test(value)
}

export function validateNumT (value) {
  var parten = /^\d{3}$/
  return parten.test(value)
}

// 0-30
export function validateNumThree (value) {
  var parten = /^30$|^([1-3]\d)$|^\d?$/
  return parten.test(value)
}

// 0-60
export function validateNumSix (value) {
  var parten = /^60$|^([1-6]\d)$|^\d?$/
  return parten.test(value)
}

// 0-100
/**
 * 验证数字是否符合特定规则
 * 该函数用于检查输入的数字是否为1到100之间的整数，包括1和100
 * 符合条件的数字必须是单个数字（如1-9），两位数字（如10-99），或者是100
 * 这是为了确保数字在指定的范围内，且不接受小数或负数
 *
 * @param {number} value - 待验证的数字
 * @returns {boolean} - 如果数字符合要求，则返回true；否则返回false
 */
export function validateNumTen (value) {
  // 定义一个正则表达式，用于匹配1到100之间的整数
  var parten = /^(\\d|[1-9]\\d|100)$/
  // 使用正则表达式的test方法检查给定的值是否符合规则
  return parten.test(value)
}

/**
 * 验证空格(/(^\s*)|(\s*$)/g, '')
 * @param {String} value
 */

/**
 * 验证密码 /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/
 * @param {String} value 密码
 */
export function validatePass (value) {
  var pass = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
  return pass.test(value)
}

/**
 ** 乘法函数，用来得到精确的乘法结果
 ** 说明：javascript的乘法结果会有误差，在两个浮点数相乘的时候会比较明显。这个函数返回较为精确的乘法结果。
 ** 调用：accMul(arg1,arg2)
 ** 返回值：arg1乘以 arg2的精确结果
 **/
export function accMul (arg1, arg2) {
  var m = 0
  var s1 = arg1.toString()
  var s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) {}
  try {
    m += s2.split('.')[1].length
  } catch (e) {}
  return (
    (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
    Math.pow(10, m)
  )
}

// 驼峰转下划线
export function toLine (name) {
  return name.replace(/([A-Z])/g, '_$1').toLowerCase()
}

// 下划线转驼峰
export function toHump (name) {
  return name.replace(/\_(\w)/g, function (all, letter) {
    return letter.toUpperCase()
  })
}

// 将Object内所有的key转为驼峰
export function humpObject (obj = {}) {
  const newObj = {}
  Object.keys(obj).forEach(key => {
    newObj[toHump(key)] = obj[key]
  })
  return newObj
}

// 阶段一改造：递归将对象及嵌套对象/数组内所有的 key 转为驼峰
// 用于 request.js 响应拦截器，将后端返回的 snake_case 统一转为 camelCase
export function humpObjectDeep (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }
  // 处理数组：遍历每个元素递归转换
  if (Array.isArray(obj)) {
    return obj.map(item => humpObjectDeep(item))
  }
  // 仅处理普通对象，跳过 Date、Blob、File、FormData 等特殊对象
  if (typeof obj !== 'object' || obj instanceof Date || obj instanceof Blob || obj instanceof File || obj instanceof FormData) {
    return obj
  }
  const newObj = {}
  Object.keys(obj).forEach(key => {
    newObj[toHump(key)] = humpObjectDeep(obj[key])
  })
  return newObj
}

// 递归将对象及嵌套对象/数组内所有的 key 转为下划线
// 用于 request.js 请求拦截器，将前端 camelCase 统一转为 snake_case（与后端 Jackson SNAKE_CASE 策略匹配）
export function toSnakeCaseDeep (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }
  if (Array.isArray(obj)) {
    return obj.map(item => toSnakeCaseDeep(item))
  }
  // 仅处理普通对象，跳过 Date、Blob、File、FormData 等特殊对象
  if (typeof obj !== 'object' || obj instanceof Date || obj instanceof Blob || obj instanceof File || obj instanceof FormData) {
    return obj
  }
  const newObj = {}
  Object.keys(obj).forEach(key => {
    newObj[toLine(key)] = toSnakeCaseDeep(obj[key])
  })
  return newObj
}

// json数据序列化成url
export function jsonToUrlParams (data = {}) {
  const result = []
  Object.keys(data).forEach(key => {
    result.push(`${key}=${data[key]}`)
  })
  return result.join('&')
}

/**
 * 清理Object对象上所有的null  避免覆盖
 * @param obj
 */
export function removeNulls (obj = {}) {
  Object.keys(obj).forEach(key => {
    if (obj[key] === null) {
      delete obj[key]
    } else if (typeof obj[key] === 'object') {
      removeNulls(obj[key])
    }
  })
  return obj
}

/**
 * 判断给定的值是否为空
 * @param {*} val - 待检查的值
 * @returns {boolean} - 如果值为null或undefined，则返回true，否则返回false
 */
export function isEmpty (val) {
  // 检查值是否为null或undefined
  if (val === null || val === undefined) {
    // 如果是，则返回true
    return true
  } else {
    // 如果不是，则返回false
    return false
  }
}

/**
 * 根据参数给定的路径取获取Object的深层值
 * 如果Path是个String =>  data[path]
 * 如果Path个array ([a,b])  => data.a.b
 * @param data
 * @param path
 * @return 能沿着路径走下去就会返回数据  没有的话返回null
 */
export function getDataByPath (data, path) {
  // 是array循环取内部key 直到读取到最终数据
  if (path instanceof Array) {
    path.forEach(item => {
      // 避免报错
      if (data) {
        data = data[item]
      }
    })
  } else {
    // 这里就默认是string了
    data = data[path]
  }
  return data
}

/**
 * 传入一个字符串 如果能转为number则会返回number 如果不能则返回一个字符串
 * @param num
 * @returns {string |number }
 */
export function getNumber (num) {
  const number = Number(num, 10)
  if (isNaN(number)) {
    // Not a number return original string
    return num
  } else {
    return number
  }
}

/** 开放api */
export default {
  install (Vue) {
    Vue.prototype.$timetransition = (timestamp, format = 'Y-M-D h:m:s', bool) =>
      timetransition(timestamp, format, bool)
    Vue.prototype.$getCaption = (obj, state) => getCaption(obj, state)
    Vue.prototype.$cutout = (obj, state) => cutout(obj, state)
    Vue.prototype.$truncate = (obj, state, st) => truncate(obj, state, st)
    Vue.prototype.$dateParseTime = (str, isEnd) => dateParseTime(str, isEnd)
    Vue.prototype.$getDiffDays = (date1, date2) => getDiffDays(date1, date2)
    Vue.prototype.$isAllEqual = array => isAllEqual(array)
    Vue.prototype.$renderTerr = (nodedata, createElement, ats) =>
      renderTerr(nodedata, createElement, ats)
    Vue.prototype.$arrayUnique = arr => arrayUnique(arr)
    Vue.prototype.$formateArrData = (initialArr, name) =>
      formateArrData(initialArr, name)
    Vue.prototype.$treeText = (val, treeData) => treeText(val, treeData)
    Vue.prototype.$getParent = (array, key, str = 'id') =>
      getParent(array, key, str)
    Vue.prototype.$mergeArr = (array, key) => mergeArr(array, key)
    Vue.prototype.$download = data => download(data)
    Vue.prototype.$getdictionary = (code, data) => getdictionary(code, data)
    Vue.prototype.$validateIP = data => validateIP(data)
    Vue.prototype.$validatePort = value => validatePort(value)
    Vue.prototype.$validateNum = value => validateNum(value)
    Vue.prototype.$validateNums = value => validateNums(value)
    Vue.prototype.$validatePass = value => validatePass(value)
    Vue.prototype.$validateNumT = value => validateNumT(value)
    Vue.prototype.$validateNumThree = value => validateNumThree(value)
    Vue.prototype.$validateNumSix = value => validateNumSix(value)
    Vue.prototype.$ExistsSameValues = (a1, a2) => ExistsSameValues(a1, a2)
    Vue.prototype.$rTime = date => rTime(date)
    Vue.prototype.$removeArray = date => removeArray(date)
    Vue.prototype.$debounce = (fn, wait) => debounce(fn, wait)
    Vue.prototype.$arrayObjUnique = data => arrayObjUnique(data)
    // -------------------------------------------brian
    Vue.prototype.$_throttle = (func, delay) => _throttle(func, delay)
    Vue.prototype.$_debounce = (func, delay) => _debounce(func, delay)
  }
}
